module.exports = __webpack_public_path__ + "static/counselling1-7024440fbfea8e060c753a500ef44e49.png";